import React from "react";
import Adminhomemenu from "../Menus/Adminhomemenu";

export default function AboutEasyITI() {
  return (
    <>
      <Adminhomemenu title="EasyITI" />

      <div
        className="container-fluid bg-light"
        style={{
          minHeight: "100vh",
          paddingTop: "90px",
          paddingBottom: "40px",
          overflowY: "auto",
        }}
      >
        <div className="container" style={{
          minHeight: "100vh",
          paddingTop: "90px",
          paddingBottom: "40px",
          overflowY: "auto",
        }}>

          {/* HEADER */}
          <div className="card shadow-lg mb-4 border-0">
            <div className="card-body text-center bg-primary text-white rounded">
              <h2 className="mb-2">📘 About EasyITI</h2>

              <p className="mb-0">
                Smart Digital Platform for ITI Students & Instructors 🚀
              </p>
            </div>
          </div>

          {/* ABOUT */}
          <div className="card shadow border-0 mb-4">
            <div className="card-body">
              <h4>🎯 What is EasyITI?</h4>

              <p className="text-muted">
                EasyITI is an online examination and learning platform
                specially designed for ITI students and instructors.
              </p>

              <p className="text-muted">
                The platform helps students practice MCQ questions,
                attend online tests, review answers, and improve exam
                preparation digitally.
              </p>

              <p className="text-muted">
                EasyITI provides smart digital solutions for ITI
                examination preparation with easy access from mobile
                and computer devices.
              </p>
            </div>
          </div>

          {/* FEATURES */}
          <div className="row g-4">

            {/* Instructor */}
            <div className="col-md-6">
              <div className="card h-100 shadow border-0">
                <div className="card-body">
                  <h5>👨‍🏫 Instructor Panel</h5>

                  <ul className="text-muted">
                    <li>Create Online Tests</li>
                    <li>Generate Question Papers</li>
                    <li>Manage Students</li>
                    <li>View Test History</li>
                    <li>Analyze Results</li>
                    <li>Track Student Performance</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Student */}
            <div className="col-md-6">
              <div className="card h-100 shadow border-0">
                <div className="card-body">
                  <h5>🎓 Student Panel</h5>

                  <ul className="text-muted">
                    <li>Attend Online Tests</li>
                    <li>Practice Self Tests</li>
                    <li>Join Instructor Tests</li>
                    <li>Read Questions & Answers</li>
                    <li>Check Test History</li>
                    <li>Improve Exam Preparation</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Smart Learning */}
            <div className="col-md-6">
              <div className="card h-100 shadow border-0">
                <div className="card-body">
                  <h5>📊 Smart Learning</h5>

                  <p className="text-muted">
                    EasyITI helps students improve speed, accuracy,
                    and confidence with regular online practice and
                    instant result analysis.
                  </p>

                  <p className="text-muted">
                    Students can monitor their performance and improve
                    weak areas through repeated practice tests.
                  </p>
                </div>
              </div>
            </div>

            {/* Mission */}
            <div className="col-md-6">
              <div className="card h-100 shadow border-0">
                <div className="card-body">
                  <h5>🚀 Our Mission</h5>

                  <p className="text-muted">
                    To simplify ITI examination systems and make digital
                    learning easy, fast, and accessible for every student.
                  </p>

                  <p className="text-muted">
                    We aim to support students and instructors with
                    modern online tools for better education and assessment.
                  </p>
                </div>
              </div>
            </div>

            {/* Advantages */}
            <div className="col-md-6">
              <div className="card h-100 shadow border-0">
                <div className="card-body">
                  <h5>⚡ Advantages</h5>

                  <ul className="text-muted">
                    <li>Fast Online Testing</li>
                    <li>Instant Results</li>
                    <li>Paperless Examination</li>
                    <li>Easy Mobile Access</li>
                    <li>24x7 Self Practice</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Technology */}
            <div className="col-md-6">
              <div className="card h-100 shadow border-0">
                <div className="card-body">
                  <h5>💻 Technology</h5>

                  <p className="text-muted">
                    EasyITI is built using modern web and mobile
                    technologies to provide smooth, secure, and fast
                    performance for all users.
                  </p>

                  <p className="text-muted">
                    The system supports responsive design for both
                    mobile and desktop platforms.
                  </p>
                </div>
              </div>
            </div>

          </div>

          {/* FOOTER */}
          <div className="card shadow border-0 mt-4 bg-light">
            <div className="card-body text-center">
              <h5>💙 EasyITI</h5>

              <p className="mb-0 text-muted">
                Learn Smart. Practice Daily. Achieve Success.
              </p>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}